import { clsx } from 'clsx';

import Bell from '@quick/assets/icons/bell.svg';
import X from '@quick/assets/icons/close.svg';
import { type GetNotificationsInfo } from '@quick/go-api-types/notifications/info';

import { InlineSpinner } from '@/components/core';
import { useFetch } from '@/layers/core/deal/services/useFetch';

import { useNotificationsContext } from './NotificationInteractable';

export function NotificationIcon(p: React.JSX.IntrinsicElements['div']) {
  const { data } = useFetch<GetNotificationsInfo>(
    {
      url: '/notifications/info',
      auth: true,
      allowNoAuth: true,
    },
    { dedupingInterval: 30_000, refreshInterval: 30_000 }
  );

  const {
    status: [status],
  } = useNotificationsContext();
  return (
    <div
      {...p}
      className={clsx(p.className, 'relative')}
      id="notificationsIcon"
    >
      <Bell />
      {!!data?.amount_unread && (
        <div
          className="absolute -right-1/2 -top-1/2 z-10 flex h-4 w-4 items-center justify-center
            rounded-full bg-red-700 text-white"
        >
          <span className="scale-[65%] text-sm">
            {data.amount_unread >= 10 ? '+9' : data.amount_unread}
          </span>
        </div>
      )}
      <div className="absolute -bottom-1/2 -right-1/2 z-10 flex h-4 w-4 items-center justify-center">
        {status === 0 && <InlineSpinner className="h-2 w-2" />}
        {status === 2 && <X className="h-2 w-2 text-red-600" />}
      </div>
    </div>
  );
}
